import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import ConfigurationSettingsForm from './ConfigurationSettingsForm';
import i18n from 'i18n';

interface Configuration {
    id: number | null;
    key: string;
    title: string;
    value: string;
    description: string;
    createdOn: string | null;
    updatedOn?: string | null;
    source: 'database' | 'platform_default';
}

interface ConfigurationSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeConfiguration: Configuration | null;
}

const ConfigurationSettingsModal: React.FC<ConfigurationSettingsModalProps> = React.memo(
    ({modalOpen, closeModal, activeConfiguration}) => {

        return (
            <GenericSettingsModal
                isOpen={modalOpen}
                onClose={closeModal}
                title={activeConfiguration?.source === 'platform_default' ? i18n.t('jt_override_default_configuration.text') : i18n.t('jt_edit_configuration.text')}
                entityId={activeConfiguration?.id || undefined}
                entityIdPropName="configurationId"
                FormComponent={ConfigurationSettingsForm}
                formProps={{
                    configurationData: activeConfiguration
                }}
            />
        );
    }
);

export default ConfigurationSettingsModal;

